import React, { useCallback } from "react";
import { Footer } from "@bloomberg/media-ui-nav";
import { type SubmenuItem } from "@bloomberg/media-ui-nav/dist/types";

import GoogleAnalyticsEventTracker from "~utils/GoogleAnalyticsEventTracker";

import styles from "./styles.module.css";

const tracker = new GoogleAnalyticsEventTracker({
    category: "footer",
});

export const addPrivacyManager = (link: HTMLButtonElement) => {
    window.cmpClient.cmd.push(() => {
        const cmpClient = window.getCmpClient();
        cmpClient.addPrivacyManager(link);
    });
};

const FooterComponent = ({
    footerMenuItems,
}: {
    footerMenuItems?: Record<string, SubmenuItem>;
}) => {
    const trackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            tracker.trackEvent({
                event: "footerClick",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    return (
        <Footer
            addPrivacyManager={addPrivacyManager}
            desktopBreakpointClassName={styles.gridFooter}
            footerMenuItems={footerMenuItems}
            trackingFunction={trackingFunction}
        />
    );
};

export default FooterComponent;
